export default __webpack_public_path__ + "static/media/l-1.1e34d673.jpg";